import clsx from "clsx";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

const baseUrl = window.__env__.BASE_CKAN_URL;

type BreadcrumbProps = {
  id: string;
  name: string;
  code: string;
};

export const Breadcrumb: FC<BreadcrumbProps> = ({ id, name, code }) => {
  const { t } = useTranslation();

  const items = [
    { label: name, url: `${baseUrl}/dataset/${code}/resource/${id}` },
    { label: t("breadcrumb.visualization") },
  ];

  return (
    <div
      className={clsx(
        "flex items-center px-4 m-auto gap-2 pt-[15px] mb-4",
        "ckan-md:w-[750px] ckan-lg:w-[970px] ckan-xl:w-[1180px] "
      )}
    >
      <a className="cursor-pointer" href={baseUrl}>
        <svg
          stroke="currentColor"
          fill="currentColor"
          stroke-width="0"
          viewBox="0 0 576 512"
          className="w-[1rem] mb-1"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"></path>
        </svg>
      </a>

      {items.map((item, idx) => {
        return (
          <React.Fragment key={`${idx}-${item.label}`}>
            {"/"}
            <a
              key={`${idx}-${item.label}`}
              href={item.url}
              className={clsx(
                item.url && "hover:underline",
                idx === 0 && "font-semibold"
              )}
            >
              {item.label}
            </a>
          </React.Fragment>
        );
      })}
    </div>
  );
};
